import { navigateTo } from "client_legacy/ndaw/navigator";
import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { IOwaNavigator, generateUrl } from "./common";

export class OnPremisesOwaNavigator implements IOwaNavigator {
	private readonly _baseOwaUrl: string;

	constructor(baseOwaUrl: string) {
		this._baseOwaUrl = baseOwaUrl;
	}

	public emailOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl(""),
			inNewWindow
		);
	}

	public composeEmailInNewWindow(): void {
		// somehow opening a "safe" way results in OWA showing email list and other elements instead of just the email editor
		// as Exchange server is not expected to be malicious, use "unsafe" open to mitigate that issue
		windowFactory.openUnsafe(
			this.generateUrl(
				"",
				{ viewmodel: "IMailComposeViewModelFactory" }
			),
			"_blank",
			"width=1000,height=600,left=100,top=100"
		);
	}

	public emailItem(_options: { id: string; inNewWindow?: boolean; }): void {
		throw new Error("It is not supported to open an email by id within on premises environment.");
	}

	public composeAppointmentInNewWindow(): void {
		// somehow opening a "safe" way results in OWA getting stuck in a loop. When clicking "Save" it will ask you whether you want to
		// leave the page because of unsaved changes. If you click "Leave" it will actually create the appointment, but refresh the page
		// so you will start to create a new appointment again. If you click "Cancel", the "Save" and "Discard" actions become unresponsive.
		// NOTE: for IE11 and Edge it appears the behavior is a bit different even using the "unsafe" way. You do get the alert, but if you
		// click "Leave" it will actually close the window. Clicking "Cancel" still results in "Save" and "Discard" becoming unresponsive.
		windowFactory.openUnsafe(
			this.generateUrl(
				"",
				{
					viewmodel: "IComposeCalendarItemViewModelFactory"
				}
			),
			"_blank",
			"width=1300,height=700,left=100,top=100"
		);
	}

	public calendarOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl(
				"",
				{
					modurl: "1"
				}
			),
			inNewWindow
		);
	}

	public appointmentItem(options: { id: string; inNewWindow?: boolean; }): void {
		const {
			id,
			inNewWindow
		} = options;

		navigateTo(
			this.generateUrl(
				"",
				{
					ItemID: id
				}
			),
			inNewWindow
		);
	}

	public peopleOverview(options: { inNewWindow?: boolean; } = {}): void {
		const {
			inNewWindow = false
		} = options;

		navigateTo(
			this.generateUrl(
				"",
				{
					modurl: "2"
				}
			),
			inNewWindow
		);
	}

	private generateUrl(relativePath: string, queryParameters?: Record<string, string | undefined>): string {
		return generateUrl(
			this._baseOwaUrl,
			relativePath,
			queryParameters
		);
	}
}
